import { Loader2 } from 'lucide-react';
import { usd } from '@/components/estimating/agreements/agreementFormat';

const taxLabel = (t) => (t.exempt ? `${t.label} (tax exempt)` : `${t.label} (${Number(t.pct).toLocaleString('en-US', { maximumFractionDigits: 3 })}%)`);

const Line = ({ label, cents, tid }) => (
  <div className="flex justify-between gap-4"><span>{label}</span><span className="tabular-nums" data-testid={tid}>{usd(cents)}</span></div>
);

// Subtotal + tax (when separate) and the total, for the ticks as they are now.
export function ProposalTotals({ totals, quoting, color }) {
  const t = totals.tax;
  return (
    <div className={`ml-auto mt-6 w-full max-w-xs space-y-1 text-sm transition-opacity ${quoting ? 'opacity-60' : ''}`} data-testid="proposal-public-totals" aria-live="polite">
      {t && !t.included && <><Line label="Subtotal" cents={totals.subtotal_cents} tid="proposal-public-subtotal" /><Line label={taxLabel(t)} cents={t.cents} tid="proposal-public-tax" /></>}
      {t?.included && t.exempt && <Line label={taxLabel(t)} cents={0} tid="proposal-public-tax" />}
      <div className="flex items-center justify-between border-t-2 pt-2 text-lg font-bold" style={{ borderColor: color }}>
        <span className="inline-flex items-center gap-2">Total{quoting && <Loader2 className="h-3.5 w-3.5 animate-spin text-[#8A8F99]" />}</span>
        <span className="tabular-nums" data-testid="proposal-public-total">{usd(totals.base_cents)}</span>
      </div>
      {t?.included && !t.exempt && <p className="text-[11px] text-[#5C6370]" data-testid="proposal-public-tax-included">Prices include {t.label}.</p>}
    </div>
  );
}

// Phones: the running total pinned to the bottom of the screen, with the send button beside it.
export function PhoneBar({ totals, quoting, color, label, busy, disabled, onSubmit }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-[#D5D8DD] bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_rgba(13,27,42,0.10)] backdrop-blur-md sm:hidden" data-testid="proposal-phone-bar">
      <div className="mx-auto flex max-w-2xl items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#8A8F99]">Your total</p>
          <p className={`font-exo text-xl font-bold tabular-nums text-[#0D1B2A] transition-opacity ${quoting ? 'opacity-60' : ''}`} data-testid="proposal-phone-total">{usd(totals.base_cents)}</p>
        </div>
        {label && (
          <button type="button" onClick={onSubmit} disabled={busy || disabled}
            className="inline-flex h-12 min-w-[9.5rem] items-center justify-center gap-2 rounded-md px-5 text-sm font-semibold text-white transition-opacity active:opacity-80 disabled:opacity-50"
            style={{ background: color }} data-testid="proposal-phone-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}{label}
          </button>
        )}
      </div>
    </div>
  );
}
